import React from 'react';
import { Col, FormGroup, Label, Input, Row } from 'reactstrap';
import { H5, Image } from 'AbstractElements';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import PostCommon from 'Component/Common/Form/Post';
import DropzoneCommon from 'Component/Common/Upload/Dropzone';
import { submitBanner } from 'Services/Features/Banner/Utils/bannerUtils';
import { setFormData, resetFormData } from 'Services/Features/Banner/bannerSlice';
import CustomLoader from 'Component/Common/CustomLoader';
import { toast } from 'react-toastify';

const BannerForm = ({ label, setRefetch }) => {
    const dispatch = useDispatch();
    const history = useNavigate();
    const data = useSelector(state => state.banner.currentBanner)
    const startUpload = useSelector(state => state.banner.loading);

    const handleSuccess = () => {
        dispatch(resetFormData());
        history(`${process.env.PUBLIC_URL}/banner`);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (data.link) {
            const urlPattern = /^(https?:\/\/)?([\w\d-]+\.)+\w{2,}(\/.*)?$/;
            if (data.link && !urlPattern.test(data.link)) {
                toast.warn("Masukkan URL yang valid!");
                return;
            }
        }
        dispatch(submitBanner({ ...data, successCallback: handleSuccess }))
    };

    const handleDiscard = (e) => {
        e.preventDefault();
        dispatch(resetFormData());
        history(`${process.env.PUBLIC_URL}/banner`);
    };
    const handleChanges = (e) => {
        const { name, value } = e.target;
        dispatch(setFormData({ [name]: value }));
    }

    const handleChangeBanner = ({ meta, file }, status) => {
        if (status === 'done') {
            dispatch(setFormData({ 'photo': file }));
        } else if (status === 'removed') {
            dispatch(setFormData({ 'photo': null }));
        }
    };


    return (
        <PostCommon title={label} handleSubmit={handleSubmit} handleDiscard={handleDiscard} >
            {startUpload && (
                <CustomLoader />
            )}
            <div>
                <Row className="mb-3">
                    <Col sm={data.photoLink ? 12 : 6}>
                        <FormGroup className='mb-3'>
                            <Label for="validationName" style={{ fontWeight: 'bold' }}>Judul :</Label>
                            <Input
                                className="form-control"
                                id="validationName"
                                type="text"
                                name="title"
                                placeholder="Masukkan judul banner..."
                                required=""
                                value={data.title}
                                onChange={handleChanges}
                            />
                        </FormGroup>
                        <FormGroup className='mb-3'>
                            <Label for="validationUrl" style={{ fontWeight: 'bold' }}>Link :</Label>
                            <Input
                                className="form-control"
                                id="validationUrl"
                                type="url"
                                name="link"
                                placeholder="Masukkan URL (contoh: https://example.com atau www.example.id atau example.co.id)"
                                required=""
                                value={data.link}
                                onChange={handleChanges}
                            />
                        </FormGroup>
                    </Col>

                    {data.photoLink ? (
                        <>
                            <Col sm="4">
                                <H5>Preview Banner</H5>
                                <Image
                                    attrImage={{
                                        className: 'img-fluid w-100',
                                        src: data.photoLink,
                                        alt: `${data.title}`,
                                        style: {
                                            height: 'auto',
                                            width: '100%',
                                            maxWidth: '600px',
                                            objectFit: 'contain',
                                            borderRadius: '8px'
                                        }
                                    }}
                                />
                            </Col>
                            <Col sm="8">
                                <DropzoneCommon
                                    label={'Banner'}
                                    inputContent={'Update banner'}
                                    handleChangeStatus={handleChangeBanner}
                                    accept="image/*"
                                    multiple={false}
                                    maxFiles={1}
                                />
                            </Col>
                        </>
                    ) : (
                        <Col sm="6">
                            <DropzoneCommon
                                label={'Banner'}
                                inputContent={'Silahkan upload banner'}
                                handleChangeStatus={handleChangeBanner}
                                accept="image/*"
                                multiple={false}
                                maxFiles={1}
                            />
                        </Col>
                    )}
                </Row>
            </div>
        </PostCommon>
    );
};

export default BannerForm;